import { Box } from '@material-ui/core'
import React from 'react'
import { useStore } from '../../../../hooks/storeHook'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

interface ProductNameMenuProps {
  onSelect: (index: number) => void

  activeIndex: number
}

export const ProductNameMenu = ({onSelect, activeIndex}: ProductNameMenuProps) => {
  const {mpcardStore: {selectedProductCards}} = useStore()

  const classes = useStyles()

  return <Box className={classes.menu}>
    <Box className={classes.list}>
      {selectedProductCards.map((card, i) => {
        const isActive = activeIndex === i
        return <Box key={card.id ?? card.moySkladProductId ?? i} onClick={() => onSelect(i)}
                    className={clsx(classes.item, isActive && classes.active)}>
          {card.attributes.find(a => a.apiAttributeId === 'name')?.currentValue || `Карточка ${i + 1}`}
        </Box>
      })}
    </Box>
  </Box>
}

const useStyles = makeStyles(
  () => ({
    menu: {
      width: 251,
      flexShrink: 0,
      boxSizing: 'border-box',
      position: 'relative',
      height: 'fit-content',
      padding: '26px 38px'
    },
    list: {
      position: 'fixed',
      height: 'calc(100vh - 164px)',
      width: '175px',
      boxSizing: 'border-box'
    },
    item: {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      padding: 16,
      backgroundColor: '#F0F2F5',
      marginBottom: 12,
      borderRadius: 8,
      fontSize: 14
    },
    active: {
      color: '#3987CF',
      fontWeight: 600,
      backgroundColor: 'white',
      boxShadow: '0 3px 12px 0 rgba(31, 54, 77, 0.15)'
    }
  }))